<template>
	<div class="employment-content-box">
		<!-- 首页搜索+职位列表 -->
		<div class="employment-search-content">
			<div class="employment-search">
				<!-- 搜索框+热门资质 -->
				<div class="employment-search-box">
					<!-- 搜索框-->
					<div class="employment-search-input">
						<div class="search-input-box">
							<el-input placeholder="搜索资质、公司" v-model="input" class="input-with-select">
								<el-select v-model="select" slot="prepend" placeholder="资质类型">
									<el-option label="设计资质" value="1"></el-option>
									<el-option label="建筑业企业资质" value="2"></el-option>
								</el-select>
							</el-input>
						</div>
						<div class="search-btn">高级查询</div>
					</div>
					<!-- 热门资质 -->
					<div class="hot-qualification">
						<!-- 图片 -->
						<div class="hot-qualification-img"></div>
						<!-- 资质类型 -->
						<div class="hot-qualification-type">
							<div>设计资质</div>
							<div class="vertical-line"></div>
							<div>建筑业企业资质</div>
							<div class="vertical-line"></div>
							<div>设计资质</div>
							<div class="vertical-line"></div>
							<div>建筑业企业资质</div>
							<div class="vertical-line"></div>
							<div>设计资质</div>
							<div class="vertical-line"></div>
							<div>建筑业企业资质</div>
							<div class="vertical-line"></div>
							<div>设计资质</div>
							<div class="vertical-line"></div>
							<div>建筑业企业资质</div>
						</div>
					</div>
				</div>
				<!-- 职位列表 -->
				<div class="job-box">
					<div class="job-box-left">
						<!-- 一级目录的职位 -->
						<div class="job-box-left-top">
							<div
								class="job-box-item"
								@mouseover="handleMouseover(i)"
								:class="{ active: num === i }"
								v-for="(i, k) in currentPageData"
								:key="k"
							>
								<div class="job-box-item-title">勘察设计{{ i }}</div>
								<div class="job-box-item-text">总建筑师/高级建筑师</div>
								<div class="job-box-item-text">结构工程师</div>
								<i class="el-icon-caret-right"></i>
							</div>
						</div>
						<!-- 分页组件 -->
						<div class="page">
							<div class="page-num">{{ currentPage }} / {{ totalPages }}</div>
							<div class="page-svg">
								<svg-icon icon-class="leftArrow" class="icon" @click="changePage(-1)" />
								<svg-icon icon-class="rightArrow" class="icon" @click="changePage(1)" />
							</div>
						</div>
					</div>
					<!-- 内容主体 -->
					<transition name="fade-transform" mode="out-in">
						<div class="job-box-center" :key="num">
							<div class="job-box-center-content">
								<div class="title">勘察设计{{ num }}</div>
								<!-- 列表 -->
								<div class="job-box-center-content-item" v-for="i in 8" :key="i">
									<div>xxx</div>
									<div>总建筑师/高级建筑师</div>
									<div>结构工程师</div>
									<div>总建筑师/高级建筑师</div>
									<div>结构工程师</div>
									<div>总建筑师/高级建筑师</div>
								</div>
							</div>
						</div>
					</transition>
					<div class="job-box-right">
						<div class="job-img1 poster-container">
							<img src="@/assets/employment/index1.png" alt="招聘无忧" />
						</div>
						<div class="job-img2 poster-container">
							<img src="@/assets/employment/index2.png" alt="招聘无忧" />
						</div>
						<div class="job-img3 poster-container">
							<img src="@/assets/employment/index3.png" alt="招聘无忧" />
						</div>
					</div>
				</div>
			</div>
		</div>

		<!-- 热招岗位 -->
		<div class="employment-hot-content">
			<div class="employment-hot-position">
				<div class="employment-hot-position-title">热招岗位</div>
				<div class="employment-hot-position-content">
					<div class="tab-pane-container">
						<!-- tab头部区域--start -->
						<div class="tab-pane-header">
							<!-- tab选项 -->
							<div class="tab-pane-navs">
								<div
									v-for="(item, index) in jobTabs"
									:key="index"
									:class="['tab-pane-item', { active: activeJobTab === index }]"
									@click="activeJobTab = index"
								>
									{{ item.name }}
								</div>
							</div>
						</div>
						<!-- tab头部区域--end -->
						<!-- tab内容区域--start -->
						<div class="tab-pane-content">
							<div :class="['tab-pane-content__item', { active: activeJobTab === 0 }]">
								<div class="job-tab-header">
									<el-tabs v-model="activeJoTabIndex" class="custom-tabs">
										<el-tab-pane
											v-for="(item, index) in jobTypeList"
											:key="`tabPane-${index}`"
											:label="item.itemName"
											:name="item.itemCode"
										></el-tab-pane>
									</el-tabs>
								</div>
								<div class="job-car-content">
									<transition name="fade-transform" mode="out-in">
										<div :key="activeJoTabIndex" class="job-card-box">
											<div class="job-card" v-for="(i, k) in 9" :key="k" @click="handleNavigationDeatil">
												<div class="job-header">
													<div class="job-title">PMC注册安全工程师</div>
													<div class="salary">15K～20K/月</div>
												</div>
												<div class="job-details">
													<span class="location">武汉-洪山区</span>
													<span class="education">本科</span>
													<span class="experience">3~5年</span>
												</div>
												<div class="company-info">
													<div class="company-name">
														<span>招聘企业：</span>
														xx建筑设计有限公司
													</div>
												</div>
												<div class="company-info">
													<div class="company-size">
														<span>企业人数：</span>
														国有企业|100-499人
													</div>
												</div>
											</div>
										</div>
									</transition>
								</div>
							</div>
							<div :class="['tab-pane-content__item', { active: activeJobTab === 1 }]">
								<div class="job-car-content">
									<transition name="fade-transform" mode="out-in">
										<div :key="activeJoTabIndex" class="job-card-box">
											<div class="job-card" v-for="(i, k) in 6" :key="k" @click="handleNavigationDeatil">
												<div class="job-header">
													<div class="job-title">PMC注册安全工程师</div>
													<div class="salary">15K～20K/月</div>
												</div>
												<div class="job-details">
													<span class="location">武汉-洪山区</span>
													<span class="education">本科</span>
													<span class="experience">3~5年</span>
												</div>
												<div class="company-info">
													<div class="company-name">
														<span>招聘企业：</span>
														xx建筑设计有限公司
													</div>
												</div>
												<div class="company-info">
													<div class="company-size">
														<span>企业人数：</span>
														国有企业|100-499人
													</div>
												</div>
											</div>
										</div>
									</transition>
								</div>
							</div>
						</div>
						<!-- tab内容区域--end -->
					</div>
					<div class="job-footer">
						<button class="cjt-button cjt-button--primary" type="button" @click="handleViewMore">查看更多</button>
					</div>
				</div>
			</div>
		</div>

		<!-- 热门人才 -->
		<div class="employment-hot-talent-content">
			<div class="employment-hot-talent-position">
				<div class="employment-hot-talent-position-title">热门人才</div>
				<div class="employment-hot-talent-position-content">
					<div class="tab-pane-container">
						<!-- tab头部区域--start -->
						<div class="tab-pane-header">
							<!-- tab选项 -->
							<div class="tab-pane-navs">
								<div
									v-for="(item, index) in talentTabs"
									:key="index"
									:class="['tab-pane-item', { active: activeTalentTab === index }]"
									@click="activeTalentTab = index"
								>
									{{ item.name }}
								</div>
							</div>
							<!-- 右侧提示信息 -->
							<div class="tab-pane-info">
								<i class="el-icon-info"></i>
								<span>谢某某于13分钟前加入人才库</span>
								<span class="date">20250424</span>
							</div>
						</div>
						<!-- tab头部区域--end -->
						<!-- tab内容区域--start -->
						<div class="tab-pane-content">
							<div :class="['tab-pane-content__item', { active: activeTalentTab === 0 }]">
								<div class="talent-tab-header">
									<el-tabs v-model="activeTalentTabIndex" class="custom-tabs">
										<el-tab-pane
											v-for="(item, index) in talentTypeList"
											:key="`tabPane-${index}`"
											:label="item.itemName"
											:name="item.itemCode"
										></el-tab-pane>
									</el-tabs>
								</div>
								<div class="talent-car-content">
									<transition name="fade-transform" mode="out-in">
										<div :key="activeTalentTabIndex" class="talent-card-box">
											<div class="talent-card" v-for="(i, k) in 9" :key="k" @click="handleToRecommend">
												<img src="~@/assets/index/index-zw2.png" alt="" />
												<div class="talent-card-item">
													<div class="talent-header">
														<div class="talent-title">PMC注册安全工程师</div>
														<div class="salary">15K～20K/月</div>
													</div>
													<div class="talent-details">
														<div class="age">25岁</div>
														<div class="education">本科</div>
														<div class="experience">3年</div>
														<div class="job-status">离职随时到岗</div>
													</div>
													<div class="company-info">
														<div class="company-name">
															<span>求职期望：</span>
															PMC注册安全工程师
														</div>
													</div>
													<div class="company-info">
														<div class="company-size">
															<span>专业证书：</span>
															建筑电工、建筑架子工
														</div>
													</div>
												</div>
											</div>
										</div>
									</transition>
								</div>
							</div>
							<div :class="['tab-pane-content__item', { active: activeTalentTab === 1 }]">
								<div class="talent-car-content">
									<transition name="fade-transform" mode="out-in">
										<div :key="activeTalentTabIndex" class="talent-card-box">
											<div class="talent-card" v-for="(i, k) in 6" :key="k" @click="handleToRecommend">
												<img src="~@/assets/index/index-zw2.png" alt="" />
												<div class="talent-card-item">
													<div class="talent-header">
														<div class="talent-title">PMC注册安全工程师</div>
														<div class="salary">15K～20K/月</div>
													</div>
													<div class="talent-details">
														<div class="age">25岁</div>
														<div class="education">本科</div>
														<div class="experience">3年</div>
														<div class="job-status">离职随时到岗</div>
													</div>
													<div class="company-info">
														<div class="company-name">
															<span>求职期望：</span>
															PMC注册安全工程师
														</div>
													</div>
													<div class="company-info">
														<div class="company-size">
															<span>专业证书：</span>
															建筑电工、建筑架子工
														</div>
													</div>
												</div>
											</div>
										</div>
									</transition>
								</div>
							</div>
						</div>
						<!-- tab内容区域--end -->
					</div>
					<div class="talent-footer">
						<button class="cjt-button cjt-button--primary" type="button" @click="handleViewMore">查看更多</button>
					</div>
				</div>
			</div>
		</div>

		<!-- 热招企业 -->
		<div class="employment-hot-enterprise-content">
			<div class="employment-hot-enterprise-position">
				<div class="employment-hot-enterprise-position-title">热招企业</div>
				<div class="employment-hot-enterprise-position-content">
					<div class="tab-pane-container">
						<!-- tab头部区域--start -->
						<div class="tab-pane-header">
							<!-- tab选项 -->
							<div class="tab-pane-navs">
								<div
									v-for="(item, index) in enterpriseTabs"
									:key="index"
									:class="['tab-pane-item', { active: activeEnterpriseTab === index }]"
									@click="activeEnterpriseTab = index"
								>
									{{ item.name }}
								</div>
							</div>
							<!-- 右侧提示信息 -->
							<div class="tab-pane-info">
								<i class="el-icon-info"></i>
								<span>谢某某于13分钟前加入人才库</span>
								<span class="date">20250424</span>
							</div>
						</div>
						<!-- tab头部区域--end -->
						<!-- tab内容区域--start -->
						<div class="tab-pane-content">
							<div :class="['tab-pane-content__item', { active: activeEnterpriseTab === 0 }]">
								<div class="enterprise-tab-header">
									<el-tabs v-model="activeEnterpriseTabIndex" class="custom-tabs">
										<el-tab-pane
											v-for="(item, index) in enterpriseTypeList"
											:key="`tabPane-${index}`"
											:label="item.itemName"
											:name="item.itemCode"
										></el-tab-pane>
									</el-tabs>
								</div>
								<div class="enterprise-car-content">
									<transition name="fade-transform" mode="out-in">
										<div :key="activeEnterpriseTabIndex" class="enterprise-card-box">
											<div class="enterprise-card" v-for="i in 3" :key="i">
												<!-- 公司信息 -->
												<div class="company-info">
													<img src="@/assets/employment/enterprise-logo.png" alt="公司logo" class="company-logo" />
													<div class="company-info-right">
														<span class="company-name">中安华力建设集团有限公司</span>
														<span class="company-details">100-499人 | 国有企业 | 房地产开发商</span>
													</div>
												</div>

												<div class="enterprise-card-content">
													<div class="enterprise-card-item" v-for="i in 3" :key="i">
														<!-- 职位信息 -->
														<div class="enterprise-info">
															<div class="enterprise-title">PMC注册安全工程师</div>
															<div class="salary">15K～20K/月</div>
														</div>

														<!-- 职位详情 -->
														<div class="enterprise-details">
															<div class="location">武汉-洪山区</div>
															<div class="education">本科</div>
															<div class="experience">3～5年</div>
														</div>
													</div>
												</div>

												<!-- 查看更多职位 -->
												<div class="view-more">
													<el-button type="text" @click="handleViewMore">
														{{ showMoreFields ? '收起' : '查看更多职位' }}
													</el-button>
													<i :class="showMoreFields ? 'el-icon-arrow-up' : 'el-icon-arrow-down'"></i>
												</div>
											</div>
										</div>
									</transition>
								</div>
							</div>
							<div :class="['tab-pane-content__item', { active: activeEnterpriseTab === 1 }]">
								<div class="enterprise-car-content">
									<transition name="fade-transform" mode="out-in">
										<div :key="activeEnterpriseTabIndex" class="enterprise-card-box">
											<div class="enterprise-card">
												<!-- 公司信息 -->
												<div class="company-info">
													<img src="@/assets/employment/enterprise-logo.png" alt="公司logo" class="company-logo" />
													<div class="company-info-right">
														<span class="company-name">中安华力建设集团有限公司</span>
														<span class="company-details">100-499人 | 国有企业 | 房地产开发商</span>
													</div>
												</div>

												<div class="enterprise-card-content">
													<div class="enterprise-card-item" v-for="i in 3" :key="i">
														<!-- 职位信息 -->
														<div class="enterprise-info">
															<div class="enterprise-title">PMC注册安全工程师</div>
															<div class="salary">15K～20K/月</div>
														</div>

														<!-- 职位详情 -->
														<div class="enterprise-details">
															<div class="location">武汉-洪山区</div>
															<div class="education">本科</div>
															<div class="experience">3～5年</div>
														</div>
													</div>
												</div>

												<!-- 查看更多职位 -->
												<div class="view-more">
													<el-button type="text" @click="handleViewMore">
														{{ showMoreFields ? '收起' : '查看更多职位' }}
													</el-button>
													<i :class="showMoreFields ? 'el-icon-arrow-up' : 'el-icon-arrow-down'"></i>
												</div>
											</div>
										</div>
									</transition>
								</div>
							</div>
						</div>
						<!-- tab内容区域--end -->
					</div>
					<div class="enterprise-footer">
						<button class="cjt-button cjt-button--primary" type="button" @click="handleViewMore">查看更多</button>
					</div>
				</div>
			</div>
		</div>

		<!-- 即将上线 -->
		<div class="banner-unopen">
			<div class="banner-gradient">
				<div class="left-bg"></div>
				<div class="right-bg"></div>
				<div class="banner-title">
					<p>
						即将上线
						<span>•</span>
						敬请期待
					</p>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		name: 'EmploymentIndex',
		components: {},
		props: {},
		data() {
			return {
				// 输入框的绑定值
				input: '',
				// 下拉框的绑定值
				select: '',
				// 当前的目录
				num: 1,
				// 当前激活的选项
				activeTab: 0,
				// 岗位当前激活项
				activeJobTab: 0,
				// 人才当前激活项
				activeTalentTab: 0,
				// 企业当前激活项
				activeEnterpriseTab: 0,
				// tab选项
				jobTabs: [
					{
						name: '推荐'
					},
					{
						name: '关注'
					}
				],
				talentTabs: [
					{
						name: '推荐'
					},
					{
						name: '关注'
					}
				],
				enterpriseTabs: [
					{
						name: '推荐'
					},
					{
						name: '关注'
					}
				],
				// 是否显示更多字段
				showMoreFields: false,
				activeJoTabIndex: '100',
				activeTalentTabIndex: '100',
				activeEnterpriseTabIndex: '100',
				jobTypeList: [
					{
						itemName: '注册安全工程师',
						itemCode: '100'
					},
					{
						itemName: '设计师',
						itemCode: '101'
					},
					{
						itemName: '总建筑师',
						itemCode: '102'
					},
					{
						itemName: '高级建筑师',
						itemCode: '103'
					},
					{
						itemName: '结构工程师',
						itemCode: '104'
					},
					{
						itemName: '设计师',
						itemCode: '105'
					},
					{
						itemName: '总建筑师',
						itemCode: '106'
					},
					{
						itemName: '高级建筑师',
						itemCode: '107'
					},
					{
						itemName: '结构工程师',
						itemCode: '108'
					},
					{
						itemName: '总建筑师',
						itemCode: '109'
					},
					{
						itemName: '高级建筑师',
						itemCode: '110'
					},
					{
						itemName: '结构工程师',
						itemCode: '111'
					},
					{
						itemName: '设计师',
						itemCode: '112'
					},
					{
						itemName: '总建筑师',
						itemCode: '113'
					}
				],
				talentTypeList: [
					{
						itemName: '注册安全工程师',
						itemCode: '100'
					},
					{
						itemName: '设计师',
						itemCode: '101'
					},
					{
						itemName: '总建筑师',
						itemCode: '102'
					},
					{
						itemName: '高级建筑师',
						itemCode: '103'
					},
					{
						itemName: '结构工程师',
						itemCode: '104'
					},
					{
						itemName: '设计师',
						itemCode: '105'
					},
					{
						itemName: '总建筑师',
						itemCode: '106'
					},
					{
						itemName: '高级建筑师',
						itemCode: '107'
					},
					{
						itemName: '结构工程师',
						itemCode: '108'
					},
					{
						itemName: '总建筑师',
						itemCode: '109'
					},
					{
						itemName: '高级建筑师',
						itemCode: '110'
					},
					{
						itemName: '结构工程师',
						itemCode: '111'
					},
					{
						itemName: '设计师',
						itemCode: '112'
					},
					{
						itemName: '总建筑师',
						itemCode: '113'
					}
				],
				enterpriseTypeList: [
					{
						itemName: '注册安全工程师',
						itemCode: '100'
					},
					{
						itemName: '设计师',
						itemCode: '101'
					},
					{
						itemName: '总建筑师',
						itemCode: '102'
					},
					{
						itemName: '高级建筑师',
						itemCode: '103'
					},
					{
						itemName: '结构工程师',
						itemCode: '104'
					},
					{
						itemName: '设计师',
						itemCode: '105'
					},
					{
						itemName: '总建筑师',
						itemCode: '106'
					},
					{
						itemName: '高级建筑师',
						itemCode: '107'
					},
					{
						itemName: '结构工程师',
						itemCode: '108'
					},
					{
						itemName: '总建筑师',
						itemCode: '109'
					},
					{
						itemName: '高级建筑师',
						itemCode: '110'
					},
					{
						itemName: '结构工程师',
						itemCode: '111'
					},
					{
						itemName: '设计师',
						itemCode: '112'
					},
					{
						itemName: '总建筑师',
						itemCode: '113'
					}
				],
				showMoreFields: false,
				// 模拟所有职位数据
				allJobData: Array.from({ length: 32 }, (_, index) => index + 1),
				// 每页显示的数量
				pageSize: 8,
				// 当前页码
				currentPage: 1,
				// 当前页数据
				currentPageData: []
			}
		},
		computed: {
			// 计算总页数
			totalPages() {
				return Math.ceil(this.allJobData.length / this.pageSize)
			}
		},
		watch: {},
		created() {
			this.updateCurrentPageData()
		},
		mounted() {},
		methods: {
			// 更新当前页数据
			updateCurrentPageData() {
				const start = (this.currentPage - 1) * this.pageSize
				const end = start + this.pageSize
				this.currentPageData = this.allJobData.slice(start, end)
				this.num = this.currentPageData[0]
			},
			// 分页点击事件处理函数
			changePage(step) {
				const newPage = this.currentPage + step
				if (newPage >= 1 && newPage <= this.totalPages) {
					this.currentPage = newPage
					this.updateCurrentPageData()
				}
			},
			handleMouseover(num) {
				this.num = num
			},
			// 切换显示更多字段
			toggleMoreFields() {
				this.showMoreFields = !this.showMoreFields
			},
			// 查看更多
			handleViewMore() {
				// 在这里添加查看更多的逻辑
				console.log('查看更多')
			},

			// 人才详情跳转
			handleToRecommend() {
				this.$router.push({
					path: '/employment/recommend'
				})
			},

			handleNavigationDeatil() {
				this.$router.push({
					path: '/employment/job-detail'
				})
			}
		}
	}
</script>

<style lang="scss" scoped>
	@import '~@/styles/tab-pane.scss';
	@import '~@/styles/element-reset.scss';
	@import '~@/styles/employment.scss';

	.employment-content-box {
		position: relative;
		background-color: #eff6f9;

		.banner-unopen {
			position: fixed;
			width: 100%;
			height: 150px;
			top: 50%;
			transform: translateY(-75px);
		}
	}

	// 首页搜索+职位列表
	.employment-search-content {
		padding-top: 47px;
		.employment-search {
			width: $main-page-width;
			height: 605px;
			margin: 0 auto;
			display: flex;
			flex-direction: column;
			justify-content: space-between;

			.employment-search-box {
				width: 1133px;
				height: 115px;
				margin: 0 auto;
				display: flex;
				flex-direction: column;
				justify-content: space-between;

				.employment-search-input {
					display: flex;
					justify-content: space-between;
					height: 60px;

					.search-input-box {
						width: 1000px;
						height: 100%;
						background-color: #ffffff;
						box-shadow: 1px 5px 18px 0px rgba(0, 128, 226, 0.13);
						border-radius: 4px;
						.input-with-select {
							height: 60px;
							:deep(.el-input-group__prepend) {
								min-width: 160px;
								background: #ffffff;
							}
							:deep(.el-input__inner) {
								height: 60px;
								font-size: 16px;
							}
						}
					}

					.search-btn {
						width: 120px;
						height: 60px;
						background-color: #236fca;
						box-shadow: 1px 5px 18px 0px rgba(0, 128, 226, 0.13);
						border-radius: 4px;
						font-size: 18px;
						font-weight: normal;
						font-stretch: normal;
						line-height: 60px;
						color: #ffffff;
						text-align: center;
						cursor: pointer;
					}
				}

				.hot-qualification {
					display: flex;
					align-items: center;
					width: 100%;
					height: 34px;
					.hot-qualification-img {
						width: 143px;
						height: 34px;
						background: url('~@/assets/employment/hot-qualification.png') 50% 50% no-repeat;
					}
					.hot-qualification-type {
						display: flex;
						justify-content: space-between;
						align-items: center;
						flex: 1;
						div {
							font-size: 16px;
							font-weight: normal;
							font-stretch: normal;
							color: #666666;
							cursor: pointer;
						}
						.vertical-line {
							width: 1px; /* 线条的宽度 */
							height: 19px; /* 线条的高度 */
							background-color: #666666; /* 线条的颜色 */
						}
					}
				}
			}

			.job-box {
				height: 460px;
				width: 100%;
				display: flex;
				justify-content: space-between;
				.job-box-left {
					display: flex;
					flex-direction: column;
					align-items: center;
					justify-content: space-between;
					height: 460px;
					width: 390px;
					background-color: #ffffff;
					box-shadow: 1px 5px 18px 0px rgba(0, 128, 226, 0.13);
					border-radius: 0px 6px 6px 6px;
					border: solid 1px rgba(35, 111, 202, 0.3);

					.job-box-left-top {
						height: 367px;
						width: 100%;
						.job-box-item {
							display: flex;
							justify-content: space-around;
							align-items: center;
							height: 50px;
							cursor: pointer;
							&:hover {
								background-color: #ffffff;
								box-shadow: 1px 5px 18px 0px rgba(0, 128, 226, 0.13);
								border-radius: 6px 0px 0px 0px;
								border: solid 1px rgba(35, 111, 202, 0.3);
								i {
									color: #236fca;
								}
							}
							.job-box-item-title {
								font-size: 16px;
								font-weight: bold;
								font-stretch: normal;
								color: #333333;
							}
							.job-box-item-text {
								font-size: 14px;
								font-weight: normal;
								font-stretch: normal;
								color: #333333;
							}
							i {
								font-size: 15px;
							}
						}
						.active {
							background-color: #ffffff;
							box-shadow: 1px 5px 18px 0px rgba(0, 128, 226, 0.13);
							border-radius: 6px 0px 0px 0px;
							border: solid 1px rgba(35, 111, 202, 0.3);
							i {
								color: #236fca;
							}
						}
					}
					.page {
						width: 350px;
						height: 43px;
						border-top: 2px solid rgb(239, 239, 239);
						display: flex;
						align-items: center;
						justify-content: space-between;
						.page-num {
							font-size: 16px;
							font-weight: normal;
							font-stretch: normal;
							line-height: 50px;
							letter-spacing: 0px;
							color: #236fca;
						}
						.page-svg {
							svg {
								cursor: pointer;
								color: #236fca;
								background: rgb(227, 239, 255);
								margin-left: 5px;
								font-size: 20px;
								&:hover {
									background: #236fca;
									color: #fff;
								}
							}
						}
					}
				}
				.job-box-center {
					background-color: #ffffff;
					box-shadow: 1px 5px 18px 0px rgba(0, 128, 226, 0.13);
					border-radius: 0px 6px 6px 6px;
					border: solid 1px rgba(35, 111, 202, 0.3);

					height: 460px;
					width: 680px;
					padding: 17px 24px 42px 24px;
					.job-box-center-content {
						width: 632px;
						height: 401px;
						.title {
							font-size: 16px;
							font-weight: bold;
							font-stretch: normal;
							color: #333333;
							height: 48px;
							cursor: pointer;
						}
						.job-box-center-content-item {
							display: flex;
							justify-content: space-between;
							font-size: 14px;
							height: 45px;
							line-height: 45px;
							cursor: pointer;
						}
					}
				}
				.job-box-right {
					height: 460px;
					width: 301px;
					display: flex;
					flex-direction: column;
					justify-content: space-between;
					.job-img1 {
						margin: 0;
					}

					.job-img2 {
						margin: 0;
					}

					.job-img3 {
						margin: 0;
					}
				}
			}
		}
	}

	// 热招岗位
	.employment-hot-content {
		padding-top: 38px;
		.employment-hot-position {
			height: 785px;
			width: 1400px;
			margin: 0 auto;
			display: flex;
			flex-direction: column;
			justify-content: space-between;
			align-items: center;
			.employment-hot-position-title {
				width: 104px;
				height: 26px;
				font-size: 26px;
				font-weight: bold;
				line-height: 26px;
				letter-spacing: 0px;
				color: #333333;
			}
			.employment-hot-position-content {
				display: flex;
				flex-direction: column;
				justify-content: space-between;
				width: 1400px;
				height: 730px;
				background-color: #ffffff;
				box-shadow: 0px 10px 16px 0px rgba(165, 194, 226, 0.13);
				border-radius: 6px;
				border: solid 1px rgba(35, 111, 202, 0.3);
				padding: 20px;

				.job-tab-header {
					display: flex;
					justify-content: center;
				}

				.job-car-content {
					padding-top: 20px;
				}

				.job-footer {
					text-align: center;
				}
			}
		}
	}

	// 热门人才
	.employment-hot-talent-content {
		padding-top: 38px;
		.employment-hot-talent-position {
			height: 785px;
			width: 1400px;
			margin: 0 auto;
			display: flex;
			flex-direction: column;
			justify-content: space-between;
			align-items: center;
			.employment-hot-talent-position-title {
				width: 104px;
				height: 26px;
				font-size: 26px;
				font-weight: bold;
				line-height: 26px;
				letter-spacing: 0px;
				color: #333333;
			}
			.employment-hot-talent-position-content {
				display: flex;
				flex-direction: column;
				justify-content: space-between;
				width: 1400px;
				height: 730px;
				background-color: #ffffff;
				box-shadow: 0px 10px 16px 0px rgba(165, 194, 226, 0.13);
				border-radius: 6px;
				border: solid 1px rgba(35, 111, 202, 0.3);
				padding: 20px;

				.talent-tab-header {
					display: flex;
					justify-content: center;
				}

				.talent-car-content {
					padding-top: 20px;
				}

				.talent-footer {
					text-align: center;
				}
			}
		}
	}

	// 热招企业
	.employment-hot-enterprise-content {
		padding-top: 38px;
		.employment-hot-enterprise-position {
			height: 785px;
			width: 1400px;
			margin: 0 auto;
			display: flex;
			flex-direction: column;
			justify-content: space-between;
			align-items: center;
			.employment-hot-enterprise-position-title {
				width: 104px;
				height: 26px;
				font-size: 26px;
				font-weight: bold;
				line-height: 26px;
				letter-spacing: 0px;
				color: #333333;
			}
			.employment-hot-enterprise-position-content {
				display: flex;
				flex-direction: column;
				justify-content: space-between;
				width: 1400px;
				height: 730px;
				background-color: #ffffff;
				box-shadow: 0px 10px 16px 0px rgba(165, 194, 226, 0.13);
				border-radius: 6px;
				border: solid 1px rgba(35, 111, 202, 0.3);
				padding: 20px;

				.enterprise-tab-header {
					display: flex;
					justify-content: center;
				}

				.enterprise-car-content {
					padding-top: 20px;
				}

				.enterprise-footer {
					text-align: center;
				}
			}
		}
	}

	::v-deep(.custom-tabs) {
		width: 1184px;
	}

	::v-deep(.custom-tabs .el-tabs__item) {
		padding: 5px 10px;
		margin-right: 30px;
	}

	::v-deep(.custom-tabs .el-tabs__header) {
		border-bottom: none;
	}

	::v-deep(.custom-tabs .el-tabs__active-bar) {
		height: 0;
	}

	::v-deep(.custom-tabs .el-tabs__header.el-tabs__nav-wrap.el-tabs__nav-prev.el-icon-arrow-left) {
		// 隐藏左侧切换按钮图标
		display: none !important;
	}

	::v-deep(.custom-tabs .el-tabs__item:is-hover) {
		color: #333333;
		border-radius: 4px;
		border: solid 1px #2671cb;
	}

	::v-deep(.custom-tabs .el-tabs__item.is-active) {
		color: #333333;
		border-radius: 4px;
		border: solid 1px #2671cb;
	}
</style>
